<template>
  <div class="edit-sidebar">
    <div class="sidebar-link-wrapper">
      <a href="" class="active" @click.prevent="changeContent($event, 'general')">General</a>
      <a href="" @click.prevent="changeContent($event, 'registration')">Registration</a>
      <a href="" @click.prevent="changeContent($event, 'rebate')">Rebates</a>
      <a href="" @click.prevent="changeContent($event, 'reward')">Rewards</a>
      <a href="" @click.prevent="changeContent($event, 'training')">Trainings</a>
      <a href="" class="back-btn" @click.prevent="back">Back</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EditSidebar',
  data () {
    return {

    }
  },
  methods: {
    changeContent (event, name) {
      document.querySelector('.active').classList.remove('active')
      event.target.classList.add('active')
      this.$bus.emit('swapComponent', { component: `${name}-content` })
    },
    back () {
      this.$router.push({ name: 'EditLoyaltyProgram' })
    }
  }
}
</script>

<style scoped>
.edit-sidebar {
  padding-right: 0;
  border-right: 1px solid #efefef;
}

.edit-sidebar a {
  display: block;
  color: #000;
  padding: 16px;
  text-decoration: none;
  font-size: 18px;
  text-align: center;
}

.edit-sidebar a.active {
  background-color: #0033ab;
  color: #fff;
}

.edit-sidebar a:hover:not(.active) {
  background-color: #6291ff;
  color: white;
}

@media screen and (max-width: 768) {
  .sidebar a {text-align: center;}
}

.sidebar-link-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.sidebar-link-wrapper .back-btn {
  margin-top: auto;
}
</style>
